import { APITypesV1 } from "@cur8/api-client";

// Both pre-printed labels belong to the same member, so swapping them between
// the two tubes passes every identity check on the screen. Naming the tube by
// its cap colour makes the operator confirm which tube the label went on.
// The colours hold in every market, and match the illustration the lab works
// from at accessioning, so they change there and here together or not at all.
const CAP_COLOURS: Record<APITypesV1.SampleType, string> = {
  [APITypesV1.SampleType.Plasma]: "green",
  [APITypesV1.SampleType.ExtendedPlasma]: "green",
  [APITypesV1.SampleType.WholeBlood]: "purple",
};

export function tubeCapColour(sampleType: APITypesV1.SampleType): string {
  return CAP_COLOURS[sampleType];
}
